<template>


    <div>

        <reservation-confirm-modal
            :is-visible="showModal"
            @close="handleModalClose"
            @onClickBtnForceReserveSelectedCustomer="onClickBtnForceReserveSelectedCustomer"
            @onClickBtnWaitReserveSelectedCustomer="onClickBtnWaitReserveSelectedCustomer"
        />
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">그룹주간표</span>
            <span class="txt">그룹 스케줄 일정을 관리하고 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="right">
                    <select-form
                        :select-data="selectFormCenter.data"
                        :select-value="selectFormCenter.value"
                        :selected-value="selectedCenterId"
                        @update:set="onUpdateSelectedCenter"
                    />
                    <select-form
                        :select-data="selectFormTeam.data"
                        :select-value="selectFormTeam.value"
                        :selected-value="selectFormTeam.selectedValue"
                        @update:set="onUpdateSelectedTeam"
                    />
                    <div v-click-outside="outsideClick" :class="{ on: selectOpen }" class="ui-select">
                        <button
                            type="button"
                            @click="selectOpen = !selectOpen"
                            :style="
                                this.allowedMenuEvent.eventCds != null &&
                                !this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')
                                    ? 'background: #f1f5f7;'
                                    : ''
                            "
                            :disabled="
                                this.allowedMenuEvent.eventCds != null &&
                                !this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')
                            "
                        >
                            <span class="txt">강사선택</span>
                        </button>
                        <ul>
                            <li>
                                <div class="com-check">
                                    <input
                                        id="select-check-all"
                                        v-model="isCheckAllTeachers"
                                        name="select-check-all"
                                        type="checkbox"
                                        @change="onChangeCheckAllTeachers"
                                    />
                                    <label for="select-check-all">전체선택</label>
                                </div>
                            </li>
                            <li v-for="(teacher, index) in centerTeachers" :key="index">
                                <div class="com-check">
                                    <input
                                        :id="`select-check-${teacher.centerStaffId}`"
                                        v-model="teacher.checked"
                                        :name="`select-check-${teacher.centerStaffId}`"
                                        type="checkbox"
                                        @change="onChangeCheckTeacher($event)"
                                    />
                                    <label :for="`select-check-${teacher.centerStaffId}`">{{ teacher.name }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <button class="com-search-reset"></button>
                </div>
            </div>
            <div class="line">
                <schedule-date-selector
                    :callback-update-date="onUpdateScheduleDateSelector"
                    :interval="7"
                    :selected-date="selectedDate"
                />
                <div class="right">
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/day')">일일스케줄</button>
                    <button class="top-link-btn on">그룹 주간표</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/teacher')">강사 주간표</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/room')">룸 스케줄표</button>
                    <!--                    <button class="top-link-btn green" @click="reservationPop = true">신규예약</button>-->
                    <button class="com-setting-btn" @click="timePop = true"><span class="blind">설정</span></button>
                </div>
            </div>
        </div>

        <div class="schedule-table-content group">
            <table class="schedule-table">
                <colgroup>
                    <col style="width: 70px" />
                    <col v-for="(n, index) in this.weekdays.length" :key="index" style="width: 216px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th v-for="(d, index) in this.weekdays" :key="index">
                            <span class="day" :class="{ today: d.value.replace(/-/g, '') === currentDate }">
                                {{ d.weekday }} {{ d.name }}
                            </span>
                            <span class="day" :style="{ color: d.holiday === 'Y' ? 'red' : 'inherit' }">
                                {{ d.holiday === 'Y' ? "휴일" : "" }}
                              </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(hour, j) in searchTimeHours.filter(
                            (vv) => weekdays.filter((v) => scheduleTable[v.value] && scheduleTable[v.value][vv]).length
                        )"
                        :key="j"
                    >
                        <td>{{ `${hour}:00` }}</td>
                        <td v-for="(day, i) in weekdays" :key="i">
                            <!--
            m0 ~ m50 : 0분부터 50분까지 (단위 5)
            h60 ~ m180 : 50분부터 180분까지 (단위 5)
            -->
                            <template
                                v-if="!isEmpty(scheduleTable[day.value]) && !isEmpty(scheduleTable[day.value][hour])"
                            >
                                <div class="grid-area group">
                                    <div
                                        v-for="(d, index) in scheduleTable[day.value][hour].lessonList.sort((a, b) => {
                                            if (a.lessonStartTime === b.lessonStartTime)
                                                return Date.parse(a.info.createdAt) - Date.parse(b.info.createdAt);
                                            return a.lessonStartTime < b.lessonStartTime;
                                        })"
                                        :key="index"
                                        :class="scheduleClass(d)"
                                        :style="scheduleStyle(d)"
                                        class="item-box group"
                                        @click="onClickScheduleItem(d)"
                                        @mouseleave="onMouseleaveSchedule(d)"
                                        @mouseover="onMouseoverSchedule(d)"
                                    >
                                        <div class="top-line">
                                            <span class="name">
                                                {{ d.titleName }}
                                                <span v-if="d.lessonOffYn" class="lessonOff">휴강</span>
                                            </span>
                                            <!-- <span class="num">{{d.lessonMemberReservationCount}}/{{d.lessonMemberMaxCount}}명 {{ d.lessonMemberWaitCount !== 0 ? `(${d.lessonMemberWaitCount})` : ''}}</span> /-->

                                            <span class="num">
                                                {{ d.members ? d.members.length : 0 }}/{{ d.lessonMemberMaxCount }}명
                                                {{
                                                    d.lessonMemberWaitCount !== 0 ? `(${d.lessonMemberWaitCount})` : ''
                                                }}
                                            </span>
                                            <!-- <span class="num">{{nowStatus(d.members, d.lessonMemberMaxCount)}}</span>-->
                                            <span class="time">
                                                {{ getHmFromTime(d.lessonStartTime) }} ~
                                                {{ getHmFromTime(d.lessonEndTime) }}
                                            </span>
                                        </div>
                                        <span class="info-txt">{{ d.lessonName }}</span>
                                        <div class="info-user">
                                            <ul class="list">
                                                <li v-for="(m, idx) in d.members" :key="idx">
                                                    <!-- :style='m.attendanceStatus === "O" ? "color:#00c7e5": m.attendanceStatus==="X" ? "color:#f64444" : ""'-->
                                                    <template v-if="m.centerCustomerName.length > 4">
                                                        <div style="display: flex; color: black; font-weight: 500">
                                                            <img
                                                                width="17px"
                                                                height="17px"
                                                                v-if="m.attendanceStatus === 'O'"
                                                                src="../../../../public/img/icons/ic_case3.png"
                                                            />
                                                            <img
                                                                width="17px"
                                                                height="17px"
                                                                v-else-if="m.attendanceStatus === 'X'"
                                                                src="../../../../public/img/icons/ic_case2.png"
                                                            />
                                                            <img
                                                                width="17px"
                                                                height="17px"
                                                                v-else
                                                                src="../../../../public/img/icons/ic_case1.png"
                                                            />
                                                            <div>
                                                                {{ m.centerCustomerName }}
                                                            </div>
                                                        </div>
                                                        <div style="display: flex">
                                                            <div style="padding-left: 2px">
                                                                <span
                                                                    :style="
                                                                        m.tickettype === 'G'
                                                                            ? 'color:rgba(51, 126, 169, 1)'
                                                                            : 'color : rgb(217, 115, 13)'
                                                                    "
                                                                >
                                                                    ({{ m.tickettype }})
                                                                </span>
                                                                {{ m.contractSeq }}/{{
                                                                    m.less_cnt_type_cd === 'U'
                                                                        ? 'F'
                                                                        : m.less_cnt_type_cd === 'W'
                                                                        ? m.resvlimitcnt + 'n'
                                                                        : m.lessonCount
                                                                }}
                                                            </div>
                                                            <img
                                                                v-if="m.memo"
                                                                width="17px"
                                                                height="17px"
                                                                src="../../../../public/img/icons/ic_memo.png"
                                                            />
                                                        </div>
                                                    </template>
                                                    <template v-if="m.centerCustomerName.length <= 4">
                                                        <div style="display: flex; color: black; font-weight: 500">
                                                            <img
                                                                width="17px"
                                                                height="17px"
                                                                v-if="m.attendanceStatus === 'O'"
                                                                src="../../../../public/img/icons/ic_case3.png"
                                                            />
                                                            <img
                                                                width="17px"
                                                                height="17px"
                                                                v-else-if="m.attendanceStatus === 'X'"
                                                                src="../../../../public/img/icons/ic_case2.png"
                                                            />
                                                            <img
                                                                width="17px"
                                                                height="17px"
                                                                v-else
                                                                src="../../../../public/img/icons/ic_case1.png"
                                                            />
                                                            <div>
                                                                {{ m.centerCustomerName }}
                                                            </div>
                                                            <div style="padding-left: 2px">
                                                                <span
                                                                    :style="
                                                                        m.tickettype === 'G'
                                                                            ? 'color:rgba(51, 126, 169, 1)'
                                                                            : 'color : rgb(217, 115, 13)'
                                                                    "
                                                                >
                                                                    ({{ m.tickettype }})
                                                                </span>
                                                                {{ m.contractSeq }}/{{
                                                                    m.less_cnt_type_cd === 'U'
                                                                        ? 'F'
                                                                        : m.less_cnt_type_cd === 'W'
                                                                        ? m.resvlimitcnt + 'n'
                                                                        : m.lessonCount
                                                                }}
                                                            </div>
                                                            <img
                                                                v-if="m.memo"
                                                                width="17px"
                                                                height="17px"
                                                                src="../../../../public/img/icons/ic_memo.png"
                                                            />
                                                        </div>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 스케줄표 시간설정 팝업 -->
        <schedule-time-setter-dlg
            :callback-cancel="onCancelScheduleTimeSetterDlg"
            :callback-confirm="onConfirmScheduleTimeSetterDlg"
            :end-hour="searchTime.endHour"
            :end-min="searchTime.endMin"
            :is-show="timePop"
            :start-hour="searchTime.startHour"
            :start-min="searchTime.startMin"
        ></schedule-time-setter-dlg>

        <!-- 정보확인 팝업 -->
        <div v-if="infoPop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="infoPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">정보확인</span>
                    <div class="info-btn-area">
                        <button @click="onClickBtnShowCustomerReservation">예약/내역보기</button>
                        <button @click="onClickBtnShowGroupLessonModify">그룹정보수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 예약내역, 그룹정보 팝업 -->
        <div v-if="reservationPop" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="onClickBtnCloseGroupReservation">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">스케쥴 상세</span>
                    <div class="com-tab">
                        <button :class="{ on: layerTab == 1 }" @click="onClickTabGroupLessonDlgLayer1">
                            예약 내역
                        </button>

                        <button :class="{ on: layerTab == 2 }" @click="onClickTabGroupLessonDlgLayer2">
                            수업 정보
                        </button>
                    </div>
                    <!-- 예약내역 -->
                    <div v-if="layerTab == 1" class="view-area">
                        <div class="top-group-info">
                            <div class="line">
                                <span class="cnt">
                                    {{
                                        nowStatus(
                                            editFieldReservCustomer.data.members,
                                            editFieldReservCustomer.data.lessonMemberMaxCount
                                        )
                                    }}
                                </span>
                                <span v-show="editFieldReservCustomer.data.rooms">
                                    수업 장소: {{ roomName(editFieldReservCustomer.data.rooms) }}
                                </span>

                                <span class="time">
                                    {{ getReplacedLessonDate(editFieldReservCustomer.data.lessonDate) }}
                                    {{ getHmFromTime(editFieldReservCustomer.data.lessonStartTime) }} ~
                                    {{ getHmFromTime(editFieldReservCustomer.data.lessonEndTime) }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="info-txt">{{ editFieldReservCustomer.data.lessonName }}</span>
                                <span v-if="editFieldReservCustomer.data.lessonOffYn" class="lessonOff">휴강</span>
                            </div>
                        </div>
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 140px" />
                                <col style="width: 570px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>회원명</th>
                                    <td>
                                        <input
                                            :value="editFieldReservCustomer.selectedCustomer.name"
                                            placeholder="회원명, 연락처(‘-’ 제외)"
                                            readonly
                                            type="text"
                                            @click="
                                                onClickBtnOpenSearchCustomer(editFieldReservCustomer.data.lessonOffYn)
                                            "
                                        />
                                        <button
                                            v-if="!editFieldReservCustomer.data.lessonOffYn"
                                            class="com-btn"
                                            readonly
                                            @click="
                                                onClickBtnOpenSearchCustomer(editFieldReservCustomer.data.lessonOffYn)
                                            "
                                        >
                                            검색
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>이용권명</th>
                                    <td>
                                        <select-form
                                            :disabled="isEmpty(editFieldReservCustomer.selectedCustomer.id)"
                                            :select-data="editFieldReservCustomer.selectFormCustomerProduct.data"
                                            :select-value="editFieldReservCustomer.selectFormCustomerProduct.value"
                                            :selected-value="
                                                editFieldReservCustomer.selectFormCustomerProduct.selectedValue
                                            "
                                            class="w440"
                                            @update:set="onUpdateSetCustomerProduct"
                                        ></select-form>
                                        <div>
                                            <span v-if="isUsedLessonCount" style="font-size: 12px; color: red">
                                                예약 횟수를 모두 소진하였습니다.
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button
                                v-if="!isUsedLessonCount && !editFieldReservCustomer.data.lessonOffYn"
                                class="com-btn blue"
                                @click="checkAllowedClickEditAction(onClickBtnReserveSelectedCustomer)"
                            >
                                예약하기
                            </button>
                        </div>
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 40px" />
                                <col style="width: 120px" />
                                <col style="width: 150px" />
                                <col style="width: 160px" />
                                <col style="width: 150px" />
                                <col style="width: 80px" />
                                <col style="width: 80px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="com-check">
                                            <input
                                                id="check-all"
                                                v-model="selectedAll"
                                                type="checkbox"
                                                @change="checkAll"
                                            />
                                            <label for="check-all"></label>
                                        </div>
                                    </th>
                                    <th>회원명</th>
                                    <th>휴대폰번호</th>
                                    <th>예약일시</th>
                                    <th>횟수</th>
                                    <th>출결</th>
                                    <th>관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="editFieldReservCustomer.data.members.length === 0">
                                    <td colspan="100">예약내역이 없습니다.</td>
                                </tr>
                                <template v-for="(m, index) in editFieldReservCustomer.data.members">
                                    <tr :id="index" style="position: relative" :key="index">
                                        <td>
                                            <div class="com-check">
                                                <input
                                                    type="checkbox"
                                                    :id="`lesson-member-${index}`"
                                                    v-model="selectedMembers"
                                                    :value="m.centerCustomerId"
                                                />
                                                <label :for="`lesson-member-${index}`"></label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="check-link">
                                                <router-link
                                                    :to="{
                                                        path: `/madmin/member/info/${centerId}`,
                                                        query: { customerId: m.centerCustomerId },
                                                    }"
                                                    class="link"
                                                >
                                                    {{ m.centerCustomerName }}
                                                </router-link>
                                            </div>
                                        </td>
                                        <td>{{ m.phone | phoneNumberFilter }}</td>
                                        <td>{{ m.reservedDate | utcToYMDHmFilter }}</td>
                                        <td
                                            v-if="m.status == '-' && m.reservationStatus === 'RW'"
                                            style="color: #4780fd"
                                        >
                                            대기
                                        </td>
                                        <td v-else>
                                            {{ m.tickettype }} {{ isEmpty(m.contractSeq) ? 0 : m.contractSeq }}/{{
                                                m.less_cnt_type_cd === 'U'
                                                    ? 'F'
                                                    : m.less_cnt_type_cd === 'W'
                                                    ? m.resvlimitcnt + 'n'
                                                    : m.lessonCount
                                            }}
                                        </td>
                                        <td v-if="m.status == '-'">
                                            <button
                                                class="com-btn red"
                                                @click="
                                                    checkAllowedClickEditAction(
                                                        onClickBtnCancelReservationCustomer,
                                                        m,
                                                        index
                                                    )
                                                "
                                            >
                                                취소
                                            </button>
                                        </td>
                                        <td v-else>
                                            <span v-if="m.status === 'O'" style="color: #00c7e5">
                                                {{ getAttendanceStatusName(m.status) }}
                                            </span>
                                            <span style="color: #f64444" v-else-if="m.status === 'X'">
                                                {{ getAttendanceStatusName(m.status) }}
                                            </span>
                                            <span v-else>
                                                {{ getAttendanceStatusName(m.status) }}
                                            </span>
                                        </td>
                                        <td>
                                            <button
                                                @click="editFieldReservCustomer.data.members.splice(index, 1, {...m, edit: !m.edit})"
                                                class="com-btn"
                                            >
                                                메모
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="m.hasMemo || m.edit">
                                        <td colspan="7">
                                            <input type="text" style="width: 575px" v-model="m.memo" placeholder='메모를 입력하세요' />
                                            <button
                                                @click="updateMemo(m.centerCustomerId, m.memo)"
                                                style="height: 24px; line-height: 24px; margin-top: 5px"
                                                class="com-btn blue"
                                            >
                                              {{ m.hasMemo ? '수정' : '저장' }}
                                            </button>
                                            <button
                                                @click="m.hasMemo ? updateMemo(m.centerCustomerId, '') : m.edit = false"
                                                class="com-btn red"
                                            >
                                              {{ m.hasMemo ? '삭제' : '취소' }}
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <template v-if="editFieldReservCustomer.data.members.length > 0">
                            <!--                        <div class="btn-line">-->
                            <!--                            <button class="com-btn" @click="checkAllowedClickEditAction(onClickBtnCancelReservationCustomer)">예약취소</button>-->
                            <!--                        </div>-->
                            <div class="reason-line">
                                <input
                                    v-model="editFieldReservCustomer.reason"
                                    class="w400"
                                    placeholder="결석일 경우, 사유를 입력해주세요."
                                    type="text"
                                />
                                <div class="right-btn">
                                    <button
                                        class="com-btn blue"
                                        @keydown.enter.prevent
                                        @click="checkAllowedClickAttendAction(onClickBtnAttendCustomers)"
                                    >
                                        출석처리
                                    </button>
                                    <button
                                        class="com-btn"
                                        @keydown.enter.prevent
                                        @click="checkAllowedClickAttendAction(onClickBtnAbsentCustomers)"
                                    >
                                        결석처리
                                    </button>
                                    <button
                                        class="com-btn outline"
                                        @keydown.enter.prevent
                                        @click="checkAllowedClickAttendAction(onSendMsg)"
                                    >
                                        문자발송
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- //예약내역 -->
                    <!-- 그룹정보 -->
                    <div v-if="layerTab == 2" class="view-area">
                        <div class="top-group-info">
                            <div class="line">
                                <span class="cnt">
                                    {{ editFieldGroupLesson.data.lessonMemberReservationCount }}/{{
                                        editFieldGroupLesson.data.lessonMemberMaxCount
                                    }}명
                                </span>
                                <span v-show="editFieldGroupLesson.data.rooms">
                                    수업 장소: {{ roomName(editFieldGroupLesson.data.rooms) }}
                                </span>
                                <span class="time">
                                    {{ getReplacedLessonDate(editFieldGroupLesson.data.lessonDate) }}
                                    {{ getHmFromTime(editFieldGroupLesson.data.lessonStartTime) }} ~
                                    {{ getHmFromTime(editFieldGroupLesson.data.lessonEndTime) }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="info-txt">{{ editFieldGroupLesson.lessonName }}</span>
                                <span v-if="editFieldGroupLesson.data.lessonOffYn" class="lessonOff">휴강</span>
                            </div>
                        </div>
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 140px" />
                                <col style="width: 570px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>강사명</th>
                                    <td>
                                        <select-form
                                            :select-data="[...selectFormTeacher.data]"
                                            :select-value="[...selectFormTeacher.value]"
                                            :selected-value="editFieldGroupLesson.selectedTeacher"
                                            class="w200"
                                            @update:set="(v) => (editFieldGroupLesson.selectedTeacher = v)"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업기간일자</th>
                                    <td>
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :disabled="editFieldGroupLesson.isModify"
                                                :start-date="editFieldGroupLesson.lessonStartDate"
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :disabled="editFieldGroupLesson.isModify"
                                                :end-date="editFieldGroupLesson.lessonEndDate"
                                            ></single-calendar>
                                        </div>
                                        <!--                                        <p class="notice-txt">종료기간이 미확정인 경우 1~2년 뒤로 설정해 놓으셔도 좋습니다.</p>-->
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업요일</th>
                                    <td>
                                        <div class="detail-check-line">
                                            <div v-for="(wd, index) in weekdayIndex" :key="index" class="com-check">
                                                <input
                                                    :id="`check-wd-${index}`"
                                                    v-model="editFieldGroupLesson.checkedDay[index]"
                                                    :disabled="editFieldGroupLesson.isModify"
                                                    false-value="X"
                                                    name="check-r1"
                                                    true-value="O"
                                                    type="checkbox"
                                                />
                                                <label :for="`check-wd-${index}`">{{ wd }}</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업시작시간</th>
                                    <td>
                                        <select-form
                                            :disabled="editFieldGroupLesson.isModify"
                                            :select-data="editFieldGroupLesson.selectFormStartTime.hourList"
                                            :select-value="editFieldGroupLesson.selectFormStartTime.hourList"
                                            :selected-value="editFieldGroupLesson.startHour"
                                            class="w100"
                                        ></select-form>
                                        <span class="dot">:</span>
                                        <select-form
                                            :disabled="editFieldGroupLesson.isModify"
                                            :select-data="editFieldGroupLesson.selectFormStartTime.minList"
                                            :select-value="editFieldGroupLesson.selectFormStartTime.minList"
                                            :selected-value="editFieldGroupLesson.startMin"
                                            class="w100"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업진행시간</th>
                                    <td>
                                        <select-form
                                            :disabled="editFieldGroupLesson.isModify"
                                            :select-data="[...editFieldGroupLesson.selectFormLessonTime.data]"
                                            :select-value="[...editFieldGroupLesson.selectFormLessonTime.value]"
                                            :selected-value="editFieldGroupLesson.selectFormLessonTime.selectedValue"
                                            class="w100"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>룸 선택</th>
                                    <td>
                                        <select-form
                                            class="w120"
                                            :select-data="['선택안함', ...rooms.data]"
                                            :select-value="[null, ...rooms.value]"
                                            :selected-value="rooms.selectedValue"
                                            @update:set="selectRoom"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>프로그램명</th>
                                    <td>
                                        <input v-model="editFieldGroupLesson.lessonName" class="w320" type="text" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>최대예약인원</th>
                                    <td>
                                        <input
                                            v-model.number="editFieldGroupLesson.lessonMemberMaxCount"
                                            class="w60 center"
                                            type="number"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>대기가능인원</th>
                                    <td>
                                        <input
                                            v-model="editFieldGroupLesson.lessonMemberWaitEnableCount"
                                            :disabled="editFieldGroupLesson.isModify"
                                            class="w60 center"
                                            type="text"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>강제휴강인원</th>
                                    <td>
                                        <div v-if='editFieldGroupLesson.data.lessonForceOffYn' class='flex'>
                                            <span class="txt" style='margin-right: 8px;'>시작시간</span>
                                            <input v-model="editFieldGroupLesson.data.lessonForceOffCondTime" :disabled="editFieldGroupLesson.isModify" class="w60 center" type="text" />
                                            <span class="txt">분 전까지</span>
                                            <input v-model="editFieldGroupLesson.lessonForceOffMemberCount" :disabled="editFieldGroupLesson.isModify" class="w60 center" type="text" />
                                            <span class="txt">명 미만으로 예약 시 휴강합니다.</span>
                                        </div>
                                        <span v-else>휴강안함</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="notice-txt">변경된 정보는 당일에만 적용됩니다.</p>
                        <div class="bottom-btn">
                            <button
                                class="com-btn"
                                @click="checkAllowedClick('SC', 5, onClickBtnModifyGroupLesson)"
                            >
                                수정하기
                            </button>
                            <button
                                class="com-btn imp-red"
                                @click="checkAllowedClick('SC', 5, onClickBtnOffGroupLessonConfirm)"
                            >
                                {{ editFieldGroupLesson.lessonOffYn == false ? '휴강하기' : '휴강취소' }}
                            </button>
                        </div>
                    </div>
                    <!-- //그룹정보 -->
                </div>
            </div>
        </div>

        <!-- 회원 검색 결과 팝업 -->
        <search-customer-dlg
            :callback-cancel="onCancelSearchCustomerDlg"
            :callback-select="onSelectSearchCustomerDlg"
            :center-id="selectedCenterId"
            :is-show="memberPop"
        ></search-customer-dlg>

        <!-- 출결승인 팝업 -->
        <attend-or-absent-success-dlg
            :callback-ok="closeAttendOrAbsentDlg"
            :datetime="attendAbsentSuccessDlg.datetime"
            :is-attend="attendAbsentSuccessDlg.isAttend"
            :is-show="attendAbsentSuccessDlg.isShow"
            :member-names="attendAbsentSuccessDlg.names"
        ></attend-or-absent-success-dlg>

        <!-- 휴강하기 확인 팝업 -->
        <div v-if="restPop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="restPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        {{ editFieldGroupLesson.lessonOffYn == false ? '휴강하기' : '휴강취소' }}
                    </span>
                    <div class="top-group-info type-black">
                        <div class="line">
                            <span class="cnt">
                                {{ editFieldGroupLesson.data.teacher.name }}
                                {{ editFieldGroupLesson.data.lessonMemberReservationCount }}/{{
                                    editFieldGroupLesson.data.lessonMemberMaxCount
                                }}
                                (명)
                            </span>
                            <span class="time">
                                {{ getReplacedLessonDate(editFieldGroupLesson.data.lessonDate) }}
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonStartTime) }} ~
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonEndTime) }}
                            </span>
                        </div>
                        <div class="line">
                            <span class="info-txt">{{ editFieldGroupLesson.lessonName }}</span>
                        </div>
                    </div>
                    <div class="cancel-info-txt">
                        <p>
                            <span class="red">
                                {{
                                    editFieldGroupLesson.lessonOffYn == false
                                        ? '회원님들에게 휴강에 대한 안내를 하셨습니까?'
                                        : ''
                                }}
                            </span>
                        </p>
                        <p>
                            {{
                                editFieldGroupLesson.lessonOffYn == false
                                    ? '해당 시간에 예약된 스케줄은 모두'
                                    : '해당 시간의 휴강이'
                            }}
                            <span class="red">취소</span>
                            됩니다.
                        </p>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="restPop = false">취소</button>
                        <button class="com-btn blue" @click="onClickBtnOffGroupLesson">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 휴강하기 완료 팝업 -->
        <div v-if="restCompletePop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="onClickBtnGroupLessonCancelComplete">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">휴강하기</span>
                    <div class="top-group-info type-black">
                        <div class="line">
                            <span class="cnt">
                                {{ editFieldGroupLesson.data.teacher.name }}
                                {{ editFieldGroupLesson.data.lessonMemberReservationCount }}/{{
                                    editFieldGroupLesson.data.lessonMemberMaxCount
                                }}
                                (명)
                            </span>
                            <span class="time">
                                {{ getReplacedLessonDate(editFieldGroupLesson.data.lessonDate) }}
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonStartTime) }} ~
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonEndTime) }}
                            </span>
                        </div>
                        <div class="line">
                            <span class="info-txt">{{ editFieldGroupLesson.lessonName }}</span>
                        </div>
                    </div>
                    <div class="cancel-info-txt">
                        <p>
                            휴강 및 예약이
                            <span class="red">취소</span>
                            되었습니다.
                        </p>
                    </div>
                    <div class="bottom-btn">
                        <!--                        <button class="com-btn" @click="restCompletePop = false">취소</button>-->
                        <button class="com-btn blue" @click="onClickBtnGroupLessonCancelComplete">확인</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import SearchCustomerDlg from '@/components/SearchCustomerDlg';
import AttendOrAbsentSuccessDlg from '@/components/AttendOrAbsentSuccessDlg';
import ScheduleTimeSetterDlg from '@/components/ScheduleTimeSetterDlg';
import ScheduleDateSelector from '@/components/ScheduleDateSelector';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import ReservationConfirmModal from '../../../components/ReservationConfirmModal.vue'

export default {
    name: 'ScheduleGroup',
    mixins: [MixinAllowedMenu],
    components: {
        SearchCustomerDlg,
        AttendOrAbsentSuccessDlg,
        ScheduleTimeSetterDlg,
        ScheduleDateSelector,
        ReservationConfirmModal,
    },
    props: {},
    computed: {
        searchTimeHours() {
            const res = [];
            const start = parseInt(this.searchTime.startHour);
            const end = parseInt(this.searchTime.endHour);

            for (let i = start; i <= end; i++) {
                res.push(i.toString().padStart(2, '0'));
            }

            return res;
        },
        topZIndex() {
            return 999;
        },
        centerStaffId() {
            return this.$store.getters['auth/staffId'];
        },
        currentDate() {
            const now = new Date();
            const year = String(now.getFullYear());
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            return `${year}${month}${day}`;
        },
    },
    data() {
        return {
            rooms: { data: [], value: [], selectedValue: null },
            centerId: '',
            staffId: '',
            weekdays: [],
            selectedDate: moment().format('YYYY-MM-DD'),
            selectedLesson: null,
            centerTeachers: [],
            centerTeacherMap: {},
            checkedTeachers: [],
            isCheckAllTeachers: true,
            scheduleList: [],
            scheduleTable: {},
            selectedCenterId: '',
            selectedTeam: '',
            selectFormCenter: {
                data: ['센터선택'],
                value: [''],
            },
            selectFormTeam: {
                data: ['팀선택'],
                value: [''],
                selectedValue: '',
            },
            selectFormTeacher: {
                data: ['선택'],
                value: [''],
                selectedValue: '',
            },
            searchTime: {
                startHour: '06',
                startMin: '00',
                endHour: '23',
                endMin: '00',
            },
            editFieldReservCustomer: {
                data: {
                    members: [],
                },
                selectedCustomer: {
                    id: '',
                    name: '',
                },
                selectFormCustomerProduct: {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                },
                selectedProduct: null,
                customerList: [],
                reason: '',
                isAttend: true,
                checkedNames: [],
            },
            attendAbsentSuccessDlg: {
                isShow: false,
                isAttend: true,
                names: [],
                datetime: '',
            },
            editFieldGroupLesson: {
                data: {},
                selectedTeacher: '',
                lessonStartDate: '',
                lessonEndDate: '',
                checkedDay: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],
                lessonStartTime: '',
                lessonEndTime: '',
                lessonTotalTime: 60,
                lessonName: '',
                lessonMemberMaxCount: 0,
                lessonMemberWaitEnableCount: 0,
                lessonForceOffMemberCount: 0,
                startHour: '',
                startMin: '',
                selectFormStartTime: {
                    hourList: [],
                    minList: [],
                },
                selectFormLessonTime: {
                    data: ['30분', '1시간', '1시간 30분', '2시간', '2시간 30분', '3시간'],
                    value: [30, 60, 90, 120, 150, 180],
                    selectedValue: 60,
                },
                isModify: true,
            },
            // -------------
            selectOpen: false,

            timePop: false, // 스케줄표 시간설정 팝업
            reservationPop: false, // 예약내역, 그룹정보 팝업
            layerTab: 1, // 예약내역, 그룹정보 팝업 탭 활성화
            infoPop: false, // 정보확인 팝업
            restPop: false, // 휴강하기 확인 팝업
            restCompletePop: false, // 휴강하기 완료 팝업
            memberPop: false,
            weekdayIndex: ['월', '화', '수', '목', '금', '토', '일'],
            isUsedLessonCount: false, // 이용권 예약 횟수 소진 여부
            pagingInfo: { ...pagingInfo },

            selectedAll: false,
            selectedMembers: [],
            showModal: false  // 모달의 표시 여부를 제어하는 상태
        };
    },
    mounted() {
        this.init();
    },
    methods: {
         // 모달 열기
        openModal() {
            this.showModal = true
        },
        // 모달 닫기
        handleModalClose() {
            this.showModal = false
        },
        getCenterHolidaysOfWeek(startDate,endDate) {
            try {
                return api.get(`/admin/api/center/${this.centerId}/holiday/week/${startDate}/${endDate}`);
            } catch (e) {
                console.warn;
            }
        },
        getCenterRoomReservation(centerRoomId) {
            const {
                centerId,
                selectFormStartHour,
                selectFormStartMin,
                selectFormLessonTime,
                scheduleRepeatWeek,
                editFieldGroupLesson,
            } = this;
            const lessonStartDate = moment(editFieldGroupLesson.data.lessonDate).format('YYYYMMDD');
            const lessonEndDate = moment(editFieldGroupLesson.data.lessonDate).format('YYYYMMDD');
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const startTime = `${editFieldGroupLesson.startHour}:${editFieldGroupLesson.startMin}:00`;
            const lessonStartDatetime = `${editFieldGroupLesson.data.lessonDate} ${startTime}`;
            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(editFieldGroupLesson.lessonTotalTime, 'minutes')
                .format(tmFormat);
            // 스웨거 검색: 룸 예약 현황 조회
            return api.get(`/admin/api/centerRoom/reservation/status/group`, {
                params: {
                    centerId,
                    lessonStartTime: startTime,
                    lessonEndTime: endTime,
                    centerRoomId,
                    lessonStartDate,
                    lessonEndDate,
                    scheduleRepeatWeek: editFieldGroupLesson.scheduleRepeatWeek,
                    centerLessonScheduleId: editFieldGroupLesson.data.centerLessonScheduleId,
                },
            });
        },
        async selectRoom(centerRoomId) {
            try {
                const { data } = await this.getCenterRoomReservation(centerRoomId);
                if (data === 1) {
                    this.rooms.selectedValue = centerRoomId;
                } else {
                    if (data) {
                        alert(data);
                    } else {
                        this.rooms.selectedValue = centerRoomId;
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        getCenterRooms() {
            return api.get(`/admin/api/centerRoom/${this.centerId}`);
        },
        async fetchCenterRooms() {
            try {
                const { data } = await this.getCenterRooms();
                this.rooms.data = data.map((element) => {
                    if (element.useYn) {
                        return element.name;
                    }
                });
                // this.rooms.data.unshift("선택안함")
                this.rooms.value = data.map((element) => {
                    if (element.useYn) {
                        return element.centerRoomId;
                    }
                });
                // this.rooms.value.unshift("")
                this.rooms.selectedValue = null;
            } catch (e) {
                console.log(e);
            }
        },
        roomName(rooms) {
            if (!rooms || !rooms.length) return '';

            return rooms[0].centerRoomName;
        },
        async updateMemo(centerCustomerId, memo) {
            const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedLesson;
            await api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${centerLessonScheduleId}/${centerCustomerId}`,
                {
                    memo: memo,
                }
            );
            await this.fetchGroupLessonReserve();
        },
        async removeMemo(centerCustomerId) {
            const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedLesson;

            await api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${centerLessonScheduleId}/${centerCustomerId}`,
                {
                    memo: '',
                }
            );

            await this.fetchGroupLessonReserve();
        },
        deleteCheckGroupLesson(startDate, endDate, masterId, billStat) {
            return api.get(`/admin/api/center/${this.centerId}/lesson/calculate/search`, {
                params: {
                    ...this.pagingInfo,
                    startDate: moment(startDate).format('YYYYMMDD'),
                    endDate: moment(endDate).format('YYYYMMDD'),
                    centerLessonScheduleMasterID: masterId,
                    billStatus: billStat,
                },
            });
        },
        async init() {
            // 로컬스토리지에 저장한 시간이
            if (this.checkSearchTime()) {
                // 있을경우..
                this.searchTime.startHour = localStorage.getItem('startTime');
                this.searchTime.endHour = localStorage.getItem('endTime');
            }

            this.centerId = parseInt(this.$store.getters['auth/cId']);
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            await this.getAWeek(this.selectedDate);
            await this.fetchCenterRooms();
            this.editFieldGroupLesson.selectFormStartTime.hourList = Utils.getHourList();
            this.editFieldGroupLesson.selectFormStartTime.minList = Utils.getMinsList();

            // 센터 선택
            await this.fetchCenterChains();
            this.selectedCenterId = this.centerId;

            // 강사 데이터 입력 후 전체 선택
            await this.fetchCenterTearchers();
            this.isCheckAllTeachers = true;
            // 모든 직원의 스케줄확인 권한 처리
            if (!this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')) {
                this.isCheckAllTeachers = false;
            }
            this.checkAllTeachers(this.isCheckAllTeachers);

            await this.fetchGroupLessonSchedule();
            await this.fetchCenterTeams(); // 팀 조회

            console.log('일정', this.scheduleTable);
        },
        checkSearchTime() {
            let answer = false;
            try {
                const startTime = localStorage.getItem('startTime');
                const endTime = localStorage.getItem('endTime');
                if (startTime) answer = true;
                if (endTime) answer = true;
            } catch (error) {
                answer = false;
            }
            return answer;
        },
        // 전체 선택
        checkAll() {
            if (this.selectedAll) {
                this.selectedMembers = this.editFieldReservCustomer.data.members.map(
                    (member) => member.centerCustomerId
                );
            }
        },
        async fetchGroupLessonSchedule() {
            if (Utils.isEmpty(this.selectedCenterId)) {
                return;
            }

            try {
                 await this.getAWeek(this.selectedDate);

                const { data } = await this.getGroupLessonSchedule(this.selectedCenterId);

                this.scheduleTable = {};

                let zIndex = 200;
                for (const d of data) {
                    if (d.teacher.scheduleShowYn) {
                        const dtKey = d.lessonDate;
                        const tmKey = d.lessonStartTime.split(':')[0];

                        if (Utils.isEmpty(this.scheduleTable[dtKey])) {
                            this.scheduleTable[dtKey] = {};
                        }
                        if (Utils.isEmpty(this.scheduleTable[dtKey][tmKey])) {
                            this.scheduleTable[dtKey][tmKey] = {
                                count: 0,
                                lessonList: [],
                            };
                        }

                        d.titleName = '';
                        d.titleName = d.teacher.name;

                        d.startMin = parseInt(d.lessonStartTime.split(':')[1]);
                        if (d.lessonTotalTime === 0 || Utils.isEmpty(d.lessonTotalTime)) {
                            const lessSt = moment(`${d.lessonDate} ${d.lessonStartTime}`, 'YYYY-MM-DD HH:mm:ss+00');
                            const lessEd = moment(`${d.lessonDate} ${d.lessonEndTime}`, 'YYYY-MM-DD HH:mm:ss+00');
                            const diff = (lessEd.unix() - lessSt.unix()) / 60;
                            d.lessonTotalTime = diff;
                        }

                        d.zIndex = zIndex;
                        this.scheduleTable[dtKey][tmKey].lessonList.push(d);
                        this.scheduleTable[dtKey][tmKey].count++;

                        // 2021.01.12 notbadlife@evb
                        // vue 인스턴스에서 감지하게 하기 위해 객체 유지.
                        // 해당 부분이 없으면 zIndex 변화를 실시간 적용하지 못한다.
                        // scheduleList는 반드시 인스턴스의 데이터에 선언할 것
                        this.scheduleList.push(d);

                        zIndex++;
                    }
                }

                for (const [dtKey, hourObject] of Object.entries(this.scheduleTable)) {
                    for (const [hour, schedule] of Object.entries(hourObject)) {
                        schedule.cols = schedule.count;
                    }
                }

                /*
scheduleTable : {
"YYYY-MM-DD" : {
"07" : {
count: 2,
lessonList: [ {}, {}, ... ]
},
"08" : {
count: 2,
lessonList: [ {}, {}, ... ]
},
...
},
"YYYY-MM-DD" : {
"07" : {
count: 2,
lessonList: [ {}, {}, ... ]
},
...
},
...
}
*/
            } catch (e) {
                console.log(e);
            }
        },
        async fetchCenterChains() {
            try {
                const { data } = await this.getCenterChains();
                const obj = Utils.getSelectFormObjectFromArray('centerName', 'id', data);
                this.selectFormCenter.data = obj.data;
                this.selectFormCenter.value = obj.value;
            } catch (e) {
                console.log(e);
            }
        },
        async fetchCenterTeams() {
            try {
                const { data } = await this.getCenterTeams();
                const obj = Utils.getSelectFormObjectFromArray('name', 'centerTeamId', data, '팀선택', '');
                this.selectFormTeam.data = obj.data;
                this.selectFormTeam.value = obj.value;
            } catch (e) {
                console.log(e);
            }
        },
        async fetchCenterTearchers() {
            try {
                const { data } = await this.getCenterTearchers();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );

                this.centerTeachers = data;
                this.centerTeacherMap = {};

                for (const t of this.centerTeachers) {
                    this.centerTeacherMap[t.centerStaffId] = t;
                }

                const obj = Utils.getSelectFormObjectFromArray('name', 'centerStaffId', data, '선택');
                this.selectFormTeacher.data = obj.data;
                this.selectFormTeacher.value = obj.value;
            } catch (e) {
                console.log(e);
            }
        },
        async fetchCustomerProductTicket() {
            if (Utils.isEmpty(this.editFieldReservCustomer.selectedCustomer.id)) {
                return false;
            }

            try {
                let { data } = await this.getCustomerProductTicket(this.editFieldReservCustomer.selectedCustomer.id);

                // 모든 이용권의 예약 권한 적용(SC_EVENT_007)
                if (
                    this.allowedMenuEvent.eventCds != null &&
                    !this.allowedMenuEvent.eventCds.includes('SC_EVENT_007')
                ) {
                    data.items = data.items.filter((value) => value.cc_staff_id == this.staffId);
                }

                data = data.items.filter((value) => value.cc_diff_day >= 0);
                data = data.filter((value) => value.cp_ticket_type_cd === 'G' || value.cp_ticket_type_cd === 'C');

                this.editFieldReservCustomer.selectFormCustomerProduct.data = ['이용권 선택'];
                this.editFieldReservCustomer.selectFormCustomerProduct.value = [''];
                this.editFieldReservCustomer.selectFormCustomerProduct.list = [...data];

                // [듀엣] 플라잉요가 (2/8) 2019-11-09 ~ 2020-12-08
                const len = data.length;
                for (let i = 0; i < len; i++) {
                    const d = data[i];
                    // if (Utils.isEmpty(d.centerProduct)) {
                    //     // 데이터 정합성 오류 : 상품 정보 없음
                    //     continue;
                    // }
                    //
                    // else
                    if (d.resv_total_cnt === d.cc_less_cnt && d.resv_total_cnt && d.cc_less_cnt) {
                        // 횟수가 모두 차감된 경우, 두개가 0,0이 아닐ㄹ경우..
                        continue;
                    }
                    const typeName = Utils.getTicketTypeName(d.cp_ticket_type_cd);
                    const lessonJoinCount = Utils.isEmpty(d.resv_total_cnt) ? 0 : d.resv_total_cnt;
                    const productName = `[${typeName}] ${d.ccp_prod_nm} (${lessonJoinCount}/${d.cc_less_cnt}) ${moment(
                        d.cc_exp_start_dt
                    ).format('YYYY-MM-DD')} ~ ${moment(d.cc_exp_end_dt).format('YYYY-MM-DD')}`;
                    this.editFieldReservCustomer.selectFormCustomerProduct.data.push(productName);
                    this.editFieldReservCustomer.selectFormCustomerProduct.value.push(i);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async fetchGroupLessonReserve() {
            try {
                const { data } = await this.getCenterScheduleGroupLesson(this.selectedLesson.centerLessonScheduleId);
                this.editFieldReservCustomer.data = data;
                this.editFieldReservCustomer.data.members.forEach(m => m.hasMemo = !!m.memo)
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async fetchGroupLessonDetail() {
            try {
                const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedLesson;
                const { data } = await this.getCenterScheduleGroupLessonDetail(
                    centerLessonScheduleId,
                    centerLessonScheduleMasterId
                );
                const { editFieldGroupLesson } = this;
                const { schedulerMaster } = data;
                const startTimes = data.lessonStartTime.split(':');
                editFieldGroupLesson.data = data;
                editFieldGroupLesson.selectedTeacher = data.lessonStaffId;
                editFieldGroupLesson.startHour = startTimes[0];
                editFieldGroupLesson.startMin = startTimes[1];
                editFieldGroupLesson.lessonOffYn = data.lessonOffYn;
                editFieldGroupLesson.lessonName = data.lessonName;
                editFieldGroupLesson.lessonMemberMaxCount = data.lessonMemberMaxCount;
                editFieldGroupLesson.lessonMemberWaitEnableCount = data.lessonMemberWaitEnableCount;
                editFieldGroupLesson.lessonForceOffMemberCount = data.lessonForceOffMemberCount;
                editFieldGroupLesson.selectFormLessonTime.selectedValue = data.lessonTotalTime;
                editFieldGroupLesson.lessonStartDate = schedulerMaster.lessonStartDate;
                editFieldGroupLesson.lessonEndDate = schedulerMaster.lessonEndDate;
                editFieldGroupLesson.scheduleRepeatWeek = schedulerMaster.scheduleRepeatWeek;
                if (editFieldGroupLesson.data.rooms) {
                    this.rooms.selectedValue = editFieldGroupLesson.data.rooms[0].centerRoomId;
                } else {
                    this.rooms.selectedValue = null;
                }
                editFieldGroupLesson.checkedDay = editFieldGroupLesson.scheduleRepeatWeek.split(':');
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        onClickScheduleItem(item) {
            this.selectedLesson = item;

            this.infoPop = true;
        },
        async onClickTabGroupLessonDlgLayer1() {
            this.layerTab = 1;
            await this.fetchGroupLessonReserve();
        },
        async onClickTabGroupLessonDlgLayer2() {
            this.layerTab = 2;
            await this.fetchGroupLessonDetail();
        },
        onClickBtnCloseGroupReservation() {
            this.closeGroupReservation();
        },
        async onClickBtnCancelReservationCustomer(item, index) {
            if (!confirm(item.reservationStatus === 'RW' ? '대기취소 하시겠습니까?' : '삭제하시겠습니까?')) {
                return false;
            }

            const { centerCustomerId } = item;
            const { centerLessonScheduleMasterId, centerLessonScheduleId } = this.selectedLesson;

            const params = {
                scheduleMasterId: centerLessonScheduleMasterId,
                scheduleId: centerLessonScheduleId,
                customerId: centerCustomerId,
                attendanceDevice: 'AW',
                scheduleCancelReason: '',
                couponYn: false, // 쿠폰 이용권 여부
            };

            // 메모창 지우기..
            try {
                document.getElementById(`${index}-1`).remove();
            } catch (e) {}
            try {
                const { data } = await this.deleteLessonSchedule(params);
                await this.fetchGroupLessonReserve();
                alert('삭제가 완료되었습니다.');
            } catch (e) {
                console.error(e);
                Utils.alertResponseErrorMessge(e);
            }
            // const { ids, names } = this.getCheckedGroupLessonCustomerIdsAndNames();

            // if(!this.validateAttendAbsent(ids)) {
            //     return false;
            // }

            // if(confirm("선택된 회원들의 예약을 취소하시겠습니까?")) {
            //     console.log(this.selectedReservation);

            //     try {
            //         const { centerLessonScheduleMasterId, centerLessonScheduleId } = this.selectedLesson;

            //         for (let id of ids) {
            //             let params = {
            //                 scheduleMasterId : centerLessonScheduleMasterId,
            //                 scheduleId : centerLessonScheduleId,
            //                 customerId : id,
            //                 attendanceDevice : 'AW',
            //                 scheduleCancelReason : '',
            //                 couponYn:false,// 쿠폰 이용권 여부
            //             }

            //             const { data } = await this.deleteLessonSchedule(params);
            //             console.log(data);
            //         }

            //         await this.fetchGroupLessonReserve();
            //     }
            //     catch (e) {
            //         console.log(e);
            //         Utils.alertResponseErrorMessge(e);
            //     }
            // }
        },
        async onClickBtnGroupLessonCancelComplete() {
            this.reservationPop = false;
            this.restPop = false;
            this.restCompletePop = false;

            await this.fetchGroupLessonSchedule();
        },
        async onClickBtnModifyGroupLesson() {
            const { editFieldGroupLesson } = this;
            const check = await this.deleteCheckGroupLesson(
                this.selectedLesson.lessonDate,
                this.selectedLesson.lessonDate,
                this.selectedLesson.centerLessonScheduleMasterId
            );
            for (let i = 0; i < check.data.items.length; i++) {
                if (
                    check.data.items[i].clsc_atnd_status_cd === '-' &&
                    check.data.items[i].clsc_resv_status_cd !== 'RW'
                ) {
                } else {
                    alert('정산완료 된 수업이 있습니다. 정산을 취소 후 강사 변경을 해주세요.');
                    return false;
                }
            }
            if (editFieldGroupLesson.lessonMemberMaxCount < editFieldGroupLesson.data.lessonMemberReservationCount) {
                const limitCount = editFieldGroupLesson.data.lessonMemberReservationCount;
                const msg = `현재 예약인원이 ${limitCount}명입니다. ${limitCount}명 이하로는 수정할 수 없습니다.`;
                alert(msg);
                return false;
            }

            if (!confirm('수업정보를 수정하시겠습니까?\n변경된 정보는 당일에만 적용됩니다.')) {
                return false;
            }

            try {
                const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.editFieldGroupLesson.data;
                const { selectedTeacher, lessonName, lessonMemberMaxCount } = this.editFieldGroupLesson;
                const params = {
                    centerLessonScheduleId,
                    lessonStaffId: selectedTeacher,
                    lessonName,
                    lessonMemberMaxCount,
                    eventType: 'SC',
                    eventContent: '그룹레슨 단건수정',
                    centerRoomId: this.rooms.selectedValue,
                };

                await this.putGroupLessonOneModify(centerLessonScheduleMasterId, params);

                await this.fetchGroupLessonSchedule();
                this.reservationPop = false;
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickBtnOffGroupLessonConfirm() {
            this.restPop = true;
        },
        async onClickBtnOffGroupLesson() {
            try {
                const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.editFieldGroupLesson.data;
                if (Utils.isEmpty(centerLessonScheduleId) || Utils.isEmpty(centerLessonScheduleMasterId)) {
                    alert('오류가 발생하였습니다.');
                    return false;
                }

                const { data } = await this.putGroupLessonCancel(centerLessonScheduleId, centerLessonScheduleMasterId);

                // this.reservationPop = false;
                this.restPop = false;
                this.restCompletePop = true;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        checkAllowedClickAttendAction(successCallback) {
            // 출결 승인 관리 권한
            if (
                this.isAllowed('SC', 4) ||
                (this.isAllowed('SC', 3) && this.selectedLesson.lessonStaffId === this.staffId)
            ) {
                // 전체 권한이 있거나, 본인만 권한이 있는 경우
                successCallback();
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        // 출석처리
        async onClickBtnAttendCustomers() {
            const { ids, names } = this.getCheckedGroupLessonCustomerIdsAndNames();

            if (!this.validateAttendAbsent(ids)) {
                return;
            }

            if (!confirm('선택된 회원들을 출석처리 하시겠습니까?')) {
                return;
            }

            try {
                const { attendAbsentSuccessDlg } = this;
                const { data } = this.editFieldReservCustomer;

                await this.putGroupLessonAttendCustomers(data.centerLessonScheduleId, ids);

                attendAbsentSuccessDlg.datetime = `${data.lessonDate} ${this.getHmFromTime(data.lessonStartTime)}`;
                attendAbsentSuccessDlg.isAttend = true;
                attendAbsentSuccessDlg.names = names;
                attendAbsentSuccessDlg.isShow = true;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        // 결석처리
        async onClickBtnAbsentCustomers() {
            const { ids, names } = this.getCheckedGroupLessonCustomerIdsAndNames();

            if (!this.validateAttendAbsent(ids)) {
                return;
            }

            if (!confirm('선택된 회원들을 결석처리 하시겠습니까?')) {
                return;
            }

            try {
                const { attendAbsentSuccessDlg } = this;
                const { data } = this.editFieldReservCustomer;

                await this.putGroupLessonAbsentCustomers(
                    data.centerLessonScheduleId,
                    ids,
                    this.editFieldReservCustomer.reason
                );

                attendAbsentSuccessDlg.datetime = `${data.lessonDate} ${this.getHmFromTime(data.lessonStartTime)}`;
                attendAbsentSuccessDlg.isAttend = false;
                attendAbsentSuccessDlg.names = names;
                attendAbsentSuccessDlg.isShow = true;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },

        // 문자발송
        onSendMsg() {
            const data = [];
            this.selectedMembers.forEach((customerId) => {
                const customer = this.editFieldReservCustomer.data.members.find(
                    (member) => member.centerCustomerId === customerId
                );
                if (customer) {
                    data.push({
                        centerCustomerId: customer.centerCustomerId,
                        name: customer.centerCustomerName,
                        phone: customer.phone,
                    });
                }
            });
            this.$router.push({
                name: 'messageSend',
                params: { data },
            });
        },

        onClickBtnOpenSearchCustomer(lessonOffYn) {
            if (!lessonOffYn) {
                this.memberPop = true;
            }
        },
        async onClickBtnShowCustomerReservation() {
            this.openReservationDlg(1);
            await this.fetchGroupLessonReserve();
            this.infoPop = false;
        },
        async onClickBtnShowGroupLessonModify() {
            this.openReservationDlg(2);
            await this.fetchGroupLessonDetail();
            this.infoPop = false;
        },
        async onClickBtnReserveSelectedCustomer() {
            const { selectedCustomer, selectedProduct, data } = this.editFieldReservCustomer;

            if (Utils.isEmpty(selectedCustomer.id) || Utils.isEmpty(selectedProduct)) {
                !alert('회원과 이용권을 선택해주세요');
                return false;
            }

            if (!confirm('예약하시겠습니까?')) {
                return false;
            }

            try {
                const { name: centerCustomerName } = selectedCustomer;
                const { cc_center_contract_id, cp_center_prod_id, cc_center_cust_id } = selectedProduct;

                const params = {
                    centerId: this.selectedCenterId,
                    centerLessonScheduleId: data.centerLessonScheduleId,
                    centerCustomerId: cc_center_cust_id,
                    centerCustomerName,
                    centerContractId: cc_center_contract_id,
                    centerProductId: cp_center_prod_id,
                    attendanceDevice: 'AW',
                    reservationType: 'S',
                    reservationId: this.centerStaffId,
                };

                const { data: result } = await this.putGroupLessonReserveCustomer(params);
                await this.fetchGroupLessonReserve();
                await this.fetchGroupLessonSchedule();

                const { editFieldReservCustomer } = this;

                editFieldReservCustomer.selectedCustomer.id = '';
                editFieldReservCustomer.selectedCustomer.name = '';
                editFieldReservCustomer.selectFormCustomerProduct = {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                };
            } catch (e) {
                console.log(e);
                if('CAPACITY_FULL' === e.response.data.message) {
                    this.openModal();
                }else {
                    Utils.alertResponseErrorMessge(e);
                }
                //
            }
        },
        async onClickBtnWaitReserveSelectedCustomer() {


            const { selectedCustomer, selectedProduct, data } = this.editFieldReservCustomer;

            if (Utils.isEmpty(selectedCustomer.id) || Utils.isEmpty(selectedProduct)) {
                !alert('회원과 이용권을 선택해주세요');
                return false;
            }

            try {
                const { name: centerCustomerName } = selectedCustomer;
                const { cc_center_contract_id, cp_center_prod_id, cc_center_cust_id } = selectedProduct;

                const params = {
                    centerId: this.selectedCenterId,
                    centerLessonScheduleId: data.centerLessonScheduleId,
                    centerCustomerId: cc_center_cust_id,
                    centerCustomerName,
                    centerContractId: cc_center_contract_id,
                    centerProductId: cp_center_prod_id,
                    attendanceDevice: 'AW',
                    reservationType: 'S',
                    reservationId: this.centerStaffId,
                    forceReservationTypeCd : 'FW'
                };

                const { data: result } = await this.putGroupLessonReserveCustomer(params);
                await this.fetchGroupLessonReserve();
                await this.fetchGroupLessonSchedule();

                const { editFieldReservCustomer } = this;

                editFieldReservCustomer.selectedCustomer.id = '';
                editFieldReservCustomer.selectedCustomer.name = '';
                editFieldReservCustomer.selectFormCustomerProduct = {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                };
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickBtnForceReserveSelectedCustomer() {
            const { selectedCustomer, selectedProduct, data } = this.editFieldReservCustomer;

            if (Utils.isEmpty(selectedCustomer.id) || Utils.isEmpty(selectedProduct)) {
                !alert('회원과 이용권을 선택해주세요');
                return false;
            }

            try {
                const { name: centerCustomerName } = selectedCustomer;
                const { cc_center_contract_id, cp_center_prod_id, cc_center_cust_id } = selectedProduct;

                const params = {
                    centerId: this.selectedCenterId,
                    centerLessonScheduleId: data.centerLessonScheduleId,
                    centerCustomerId: cc_center_cust_id,
                    centerCustomerName,
                    centerContractId: cc_center_contract_id,
                    centerProductId: cp_center_prod_id,
                    attendanceDevice: 'AW',
                    reservationType: 'S',
                    reservationId: this.centerStaffId,
                    forceReservationTypeCd : 'FR'
                };

                const { data: result } = await this.putGroupLessonReserveCustomer(params);
                await this.fetchGroupLessonReserve();
                await this.fetchGroupLessonSchedule();

                const { editFieldReservCustomer } = this;

                editFieldReservCustomer.selectedCustomer.id = '';
                editFieldReservCustomer.selectedCustomer.name = '';
                editFieldReservCustomer.selectFormCustomerProduct = {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                };
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        onChangeCheckAllTeachers() {
            this.checkAllTeachers(this.isCheckAllTeachers);
            this.fetchGroupLessonSchedule();
        },
        onChangeCheckTeacher(event) {
            if (this.isCheckAllTeachers && !event.target.checked) this.isCheckAllTeachers = false;

            this.refreshCheckedTeachers();
            this.fetchGroupLessonSchedule();
        },
        onUpdateSetCustomerProduct(val) {
            const { selectFormCustomerProduct } = this.editFieldReservCustomer;
            selectFormCustomerProduct.selectedValue = val;

            const product = selectFormCustomerProduct.list[val];
            this.editFieldReservCustomer.selectedProduct = product;

            this.checkLessonCountOver(product);
        },
        async onUpdateScheduleDateSelector(date) {
            this.selectedDate = moment(date).format('YYYY-MM-DD');
            const tempTeachers = this.centerTeachers;

            await this.fetchCenterTearchers();
            if (this.isCheckAllTeachers) {
                this.checkAllTeachers(true);
            } else {
                for (let i = 0; i < this.centerTeachers.length; i++) {
                    for (let j = 0; j < tempTeachers.length; j++) {
                        if (
                            tempTeachers[j].checked &&
                            this.centerTeachers[i].centerStaffId === tempTeachers[j].centerStaffId
                        ) {
                            this.centerTeachers[i].checked = true;
                        }
                    }
                }
            }

            this.doAfterCalendarChanged();
        },
        onSelectSearchCustomerDlg(customer) {
            this.editFieldReservCustomer.selectedCustomer = {
                id: customer.center_cust_id,
                name: customer.namee,
            };
            const isDuplicated = this.isDuplicate(customer.centerCustomerId);
            if (isDuplicated) {
                this.editFieldReservCustomer.selectedCustomer = {};
            } else {
                this.memberPop = false;
                this.isUsedLessonCount = false;
                this.fetchCustomerProductTicket();
            }
        },
        onCancelSearchCustomerDlg() {
            this.memberPop = false;
        },
        onCancelScheduleTimeSetterDlg(times) {
            const { startHour, endHour } = times;

            this.searchTime.startHour = startHour;
            this.searchTime.endHour = endHour;

            this.timePop = false;

            this.fetchGroupLessonSchedule();
        },
        onConfirmScheduleTimeSetterDlg(times) {
            const { startHour, endHour } = times;

            this.searchTime.startHour = startHour;
            this.searchTime.endHour = endHour;
            // 시간 값을 저장..
            localStorage.setItem('startTime', startHour);
            localStorage.setItem('endTime', endHour);

            this.timePop = false;

            // this.fetchGroupLessonSchedule();
        },
        async onUpdateSelectedCenter(v) {
            this.selectedCenterId = v;

            await this.fetchCenterTeams();

            await this.fetchCenterTearchers();
            this.isCheckAllTeachers = true;
            this.checkAllTeachers(this.isCheckAllTeachers);

            await this.fetchGroupLessonSchedule();
        },
        onUpdateSelectedTeam(v) {
            this.selectFormTeam.selectedValue = v;
            // this.fetchCenterTearchers();
            this.fetchCenterTearchersByTeam();
        },
        // api
        getGroupLessonSchedule(centerId) {
            const firstMondayDate = Utils.getFirstMondayOfWeek(this.selectedDate);
            const targetDate = firstMondayDate.replace(/-/g, '');
            const staffIdList = this.getCheckedCenterTeacherIds().join(',');
            const params = {
                targetDate,
                staffIdList,
            };

            if (Utils.isEmpty(staffIdList)) {
                return { data: [] };
            }

            return api.get(`/admin/api/center/${centerId}/lesson/schedule/groupLesson/all`, { params });
        },
        getCenterChains() {
            return api.get(`/admin/api/center/${this.centerId}/chain`);
        },
        getCenterTeams() {
            return api.get(`/admin/api/center/${this.selectedCenterId}/team`);
        },
        getCenterTearchers() {
            // 스웨거 검색: 센터 강사직원 목록조회(리스트)
            return api.get(
                `/admin/api/center/${this.selectedCenterId}/staff/teachers/schedule?date=${this.selectedDate}`
            );
        },
        getCustomerProductTicket(customerId = '') {
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params: {
                    productType: 'T',
                    centerCustomerId: customerId,
                    page: 1,
                    limit: 9999,
                    totalItems: '',
                    itemCount: '',
                    totalPages: '',
                    route: '',
                },
            });
        },
        // getCustomerProductTicket(customerId = '') {
        //     const { lessonDate, centerLessonScheduleMasterId: lessonMasterId } = this.editFieldReservCustomer.data;
        //     const params = {
        //         customerId,
        //         lessonDate,
        //         lessonMasterId,
        //     };
        //
        //     // 스웨거 검색: 수강 가능한 회원 이용권 조회(카테고리 기준)
        //     return api.get(`/admin/api/center/${this.selectedCenterId}/customer/availTickets/all`, { params });
        // },
        getCenterScheduleGroupLesson(scheduleId) {
            // 스웨거: 그룹강의 예약내역 조회
            return api.get(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLesson/${scheduleId}`);
        },
        getCenterScheduleGroupLessonDetail(scheduleId, scheduleMasterId) {
            // 스웨거: 그룹강의 상세조회
            return api.get(
                `/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonDetail/${scheduleMasterId}/${scheduleId}`
            );
        },
        putGroupLessonOneModify(centerLessonScheduleMasterId, params) {
            return api.put(
                `/admin/api/center/${this.selectedCenterId}/lesson/${centerLessonScheduleMasterId}/group/one/modify`,
                { ...params }
            );
        },
        putGroupLessonCancel(scheduleId, scheduleMasterId) {
            //  스웨거 : 그룹레슨 휴강
            return api.put(
                `/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonCancel/${scheduleMasterId}/${scheduleId}`
            );
        },
        putGroupLessonReserveCustomer(params) {
            // 스웨거 검색: 그룹레슨 예약하기
            return api.put(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonReserve/customers`, {
                ...params,
            });
        },
        putGroupLessonAttendCustomers(centerLessonScheduleId, centerCustomerIds) {
            // 스웨거: 그룹레슨 출석처리
            const attendanceDevice = 'AW';
            const params = {
                centerId: this.selectedCenterId,
                centerLessonScheduleId,
                attendanceDevice,
                centerCustomerIds,
            };

            return api.put(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonAttend/customers`, {
                ...params,
            });
        },
        putGroupLessonAbsentCustomers(centerLessonScheduleId, centerCustomerIds, lessonCustomerOffReason) {
            // 스웨거: 그룹레슨 결석처리
            const attendanceDevice = 'AW';
            const params = {
                centerId: this.selectedCenterId,
                centerLessonScheduleId,
                attendanceDevice,
                centerCustomerIds,
                lessonCustomerOffReason,
            };

            return api.put(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonAbsent/customers`, {
                ...params,
            });
        },
        deleteLessonSchedule(params) {
            // scheduleMasterId, scheduleId, customerId, attendanceDevice, scheduleCancelReason
            // /admin/api/center/{centerId}/lesson/schedule/cancelLesson
            // 스웨거 검색: 예약수업 취소처리
            return api.delete(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/cancelLesson`, { params });
        },
        //
        getCheckedCenterTeacherIds() {
            const ids = [];
            this.centerTeachers.forEach((teacher) => {
                if (teacher.checked) {
                    ids.push(teacher.centerStaffId);
                }
            });
            return ids;
        },
        getCheckedGroupLessonCustomerIdsAndNames() {
            const ids = [];
            const names = [];

            this.editFieldReservCustomer.data.members.forEach((member) => {
                if (this.selectedMembers.includes(member.centerCustomerId) && this.isEditableMember(member)) {
                    ids.push(member.centerCustomerId);
                    names.push(member.centerCustomerName);
                }
            });

            return {
                ids,
                names,
            };
        },
        openReservationDlg(tabNo = 1) {
            this.layerTab = tabNo;
            this.selectedAll = false;
            this.selectedMembers = [];

            this.reservationPop = true;
        },
        closeGroupReservation() {
            this.reservationPop = false;
            this.isUsedLessonCount = false;

            // this.resetEditFieldReservCustomer();
            // this.init();

            this.fetchGroupLessonSchedule();
        },
        closeAttendOrAbsentDlg() {
            this.attendAbsentSuccessDlg.isShow = false;
            this.fetchGroupLessonReserve();
        },
        doAfterCalendarChanged() {
            // 캘린더가 변경되었을때,
            // '주'가 변경되었으면 데이터를 조회
            if (!this.isWeekdaysContainDate(this.selectedDate)) {
                this.fetchGroupLessonSchedule();
            }
        },
        checkAllTeachers(checked) {
            for (const t of this.centerTeachers) {
                // 모든 직원의 스케줄확인 권한 처리
                if (!this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')) {
                    if (t.centerStaffId == this.staffId) {
                        t.checked = true;
                    }
                } else {
                    t.checked = checked;
                }
            }

            this.refreshCheckedTeachers();
        },
        refreshCheckedTeachers() {
            this.checkedTeachers = [];
            for (const t of this.centerTeachers) {
                if (t.checked) {
                    this.checkedTeachers.push(t);
                }
            }
        },
        async getAWeek(date) {
            if (!this.isWeekdaysContainDate(date)) {
                // 포함되지 않으면 해당 날짜가 속한 일주일의 날짜를 가져옴
                const firstMondayDate = Utils.getFirstMondayOfWeek(date);
                this.weekdays =  Utils.getAWeekdays(firstMondayDate, 1, 'M/DD');
                const weekdays =  Utils.getAWeekdays(firstMondayDate, 1, 'M/DD');
                const { first, last } = Utils.getFirstAndLast(weekdays);
                if (!Utils.isEmpty(first)){
                  const {data}  =  await this.getCenterHolidaysOfWeek (first.value.replace(/-/g, ''),last.value.replace(/-/g, ''));
                  data.forEach(item => {
                    const match = weekdays.find(week => week.value === item.holidayDate);
                    // 일치하는 요소가 있으면 holiday를 'Y'로 설정
                    if (match) {
                         match.holiday = 'Y';
                     }
                  });

                  this.weekdays = weekdays;
                }
            }
        },
        scheduleStyle(item) {
            const teacher = this.centerTeacherMap[item.teacher.centerStaffId];
            if (teacher) {
                return {
                    borderColor: teacher.color,
                    zIndex: item.zIndex,
                };
            }
            return {
                borderColor: null,
                zIndex: 0,
            };
        },
        scheduleClass(item) {
            return [
                `m${item.startMin}`,
                //`h${item.lessonTotalTime}`,
            ];
        },
        isWeekdaysContainDate(date) {
            const finded = this.weekdays.find((arg) => arg.value === date);
            return !Utils.isEmpty(finded);
        },
        validateAttendAbsent(centerCustomerIds, isAbsent = false) {
            // validate
            if (centerCustomerIds.length === 0) {
                alert('회원을 선택해주세요.');
                return false;
            }
            if (isAbsent && Utils.isEmpty(this.editFieldReservCustomer.reason.trim())) {
                alert('결석이유를 입력해주세요');
                return false;
            }
            return true;
        },
        outsideClick() {
            this.selectOpen = false;
        },
        getHmFromTime(time) {
            return Utils.isEmpty(time) ? '' : time.split(':').splice(0, 2).join(':');
        },
        isEmpty(v) {
            return Utils.isEmpty(v);
        },
        getReplacedLessonDate(lessonDate) {
            return Utils.isEmpty(lessonDate) ? '' : lessonDate.replace(/-/g, '.');
        },
        getAttendanceStatusName(status) {
            return Utils.getAttendanceStatusName(status);
        },
        resetEditFieldReservCustomer() {
            const { editFieldReservCustomer } = this;

            editFieldReservCustomer.data = { members: [] };
            editFieldReservCustomer.selectedCustomer.id = '';
            editFieldReservCustomer.selectedCustomer.name = '';
            editFieldReservCustomer.selectFormCustomerProduct = {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            };
            editFieldReservCustomer.selectedProduct = null;
            editFieldReservCustomer.customerList = [];
            editFieldReservCustomer.reason = '';
            editFieldReservCustomer.isAttend = true;
            editFieldReservCustomer.checkedNames = [];
        },
        checkAllowedClickEditAction(successCallback, item, index) {
            if (this.isAllowed('SC', 1) || this.selectedLesson.lessonStaffId === this.staffId) {
                successCallback(item, index);
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        onMouseoverSchedule(item) {
            if (item.zIndex !== this.topZIndex) {
                item._zIndex = item.zIndex;
                item.zIndex = this.topZIndex;
            }
        },
        onMouseleaveSchedule(item) {
            if (!Utils.isEmpty(item._zIndex)) {
                item.zIndex = item._zIndex;
                item._zIndex = '';
            }
        },
        async fetchCenterTearchersByTeam() {
            const { data } = await this.getCenterTearchersByTeam();
            console.log('1', data);
            this.centerTeachers.forEach((teacher) => {
                teacher.checked = false;
                data.forEach((staff) => {
                    if (teacher.centerStaffId === staff.centerStaffId) {
                        teacher.checked = true;
                    }
                });
            });
            this.onChangeCheckTeacher();
        },
        getCenterTearchersByTeam() {
            return api.get(`/admin/api/center/${this.selectedCenterId}/staff/teachers/list/centerTeam`, {
                params: {
                    centerTeamId: this.selectFormTeam.selectedValue,
                },
            });
        },
        async checkLessonCountOver(product) {
            const { cc_center_id, cc_center_cust_id, cc_center_contract_id, cp_center_prod_id } = product;

            const { data } = await this.getCheckLessonCount(
                cc_center_id,
                cc_center_cust_id,
                cc_center_contract_id,
                cp_center_prod_id
            );

            this.isUsedLessonCount = data.result;
        },
        getCheckLessonCount(centerId, centerCustomerId, centerContractId, centerProductId) {
            return api.get(`/admin/api/center/${centerId}/lesson/schedule/check/less/count/over`, {
                params: {
                    centerCustomerId,
                    centerContractId,
                    centerProductId,
                },
            });
        },
        isEditableMember(member) {
            return member.reservationStatus !== 'RW' && member.status === '-';
        },
        nowStatus(member, max) {
            let answer = '';
            let rw = 0;

            let rr = 0;
            if (member === undefined || member === null) {
                return (answer = `${rr}/${max}명`);
            }
            for (let i = 0; i < member.length; i++) {
                if (member[i].reservationStatus == 'RW') {
                    rw++;
                } else {
                    rr++;
                }
            }
            if (rw) {
                answer = `${rr}/${max} 명` + ` (${rw})`;
            } else {
                answer = `${rr}/${max}명`;
            }
            return answer;
        },
        isDuplicate(id) {
            let answer = false;
            this.editFieldReservCustomer.data.members.forEach((value) => {
                if (!(value.status === '-' && value.reservationStatus === 'RW')) {
                    if (value.centerCustomerId === id) {
                        alert('예약하신 시간에 예약 내역이 있습니다.');
                        answer = true;
                    }
                }
            });
            return answer;
        },
    },
};
</script>

<style lang="scss" scoped>
.com-tab {
    margin-top: 24px;
}

.top-group-info {
    color: #535353 !important;
}

.check-link .link {
    text-decoration: underline;
}

.com-btn.outline {
    border: 1px solid #ced4da;
    background: #fff;
    color: #707070;
}
</style>
